/* ==========================================================================
   Enova - Smooth scroll
   Lenis (smooth-scroll engine) + GSAP + ScrollTrigger integration.
   Exposes `window.__enovaLenis` and `window.gsap` for other sections.
   ========================================================================== */

(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.__enovaSmoothScrollInit) return;
  window.__enovaSmoothScrollInit = true;

  var reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  var LENIS_URL = 'https://cdn.jsdelivr.net/npm/lenis@1.1.14/dist/lenis.min.js';
  var GSAP_URL = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js';
  var ST_URL =
    'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js';

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = function () {
        resolve();
      };
      s.onerror = function () {
        reject(new Error('Failed to load ' + src));
      };
      document.head.appendChild(s);
    });
  }

  function loadAll() {
    var tasks = [];
    if (!window.Lenis) tasks.push(loadScript(LENIS_URL));
    if (!window.gsap) tasks.push(loadScript(GSAP_URL));
    return Promise.all(tasks).then(function () {
      if (!window.ScrollTrigger) return loadScript(ST_URL);
    });
  }

  function init() {
    if (!window.Lenis || !window.gsap) return;

    if (window.gsap.registerPlugin && window.ScrollTrigger) {
      window.gsap.registerPlugin(window.ScrollTrigger);
    }

    var lenis = new window.Lenis({
      duration: 1.15,
      easing: function (t) {
        return Math.min(1, 1.001 - Math.pow(2, -10 * t));
      },
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.6,
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      infinite: false,
    });

    window.__enovaLenis = lenis;

    if (window.ScrollTrigger && window.ScrollTrigger.update) {
      lenis.on('scroll', window.ScrollTrigger.update);
    }

    window.gsap.ticker.add(function (time) {
      lenis.raf(time * 1000);
    });
    window.gsap.ticker.lagSmoothing(0);

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link) return;
      var hash = link.getAttribute('href');
      if (!hash || hash === '#') return;
      var target = document.querySelector(hash);
      if (!target) return;
      event.preventDefault();
      lenis.scrollTo(target, { offset: 0, duration: 1.2 });
    });

    document.addEventListener('shopify:section:load', function () {
      if (window.ScrollTrigger && window.ScrollTrigger.refresh) {
        window.ScrollTrigger.refresh();
      }
    });
  }

  loadAll()
    .then(init)
    .catch(function (err) {
      if (window.console && console.warn) {
        console.warn('[enova] smooth scroll failed to load', err);
      }
    });
})();
